
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiLguJvguKPguLDguYDguKDguJfguIHguLLguKPguIjguYnguLLguIfguIfguLLguJkifQ==!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiLguJvguKPguLDguYDguKDguJfguIHguLLguKPguIjguYnguLLguIfguIfguLLguJkifQ==!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJKZW5pcyBwZWtlcmphYW4ifQ==!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJKZW5pcyBwZWtlcmphYW4ifQ==!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJXb3JrIHR5cGUifQ==!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiLguJvguKPguLDguYDguKDguJfguIHguLLguKPguIjguYnguLLguIfguIfguLLguJkifQ==!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiLguJvguKPguLDguYDguKDguJfguIHguLLguKPguIjguYnguLLguIfguIfguLLguJkifQ==!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJKZW5pcyBwZWtlcmphYW4ifQ==!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJKZW5pcyBwZWtlcmphYW4ifQ==!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJbxbTDtsO2w7bFmcS3IOG5r8O9w73Dvcal4bq94bq94bq9XSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJ3b3JrLXR5cGUtbGFiZWwiOiJbxbTDtsO2w7bFmcS3IOG5r8O9w73Dvcal4bq94bq94bq9XSJ9!"
        )
      )
      });
  
      export { translations as default };
    